// Identité d'un brouillon de LM : client/prospect + type de lettre. Sert à ne
// remettre à jour le brouillon repris — et à ne réutiliser sa référence — que
// s'il s'agit toujours de la même LM (voir brouillonLm dans EtatGlobal.js).
export const cleBrouillon = ({ nom_client, nom, prenom, selectedForm }) =>
  `${(nom_client || `${nom || ""} ${prenom || ""}`).trim().toLowerCase()}|${(
    selectedForm || ""
  ).trim()}`;

// Référence de la LM en cours ("LM4302608035") si elle provient du brouillon
// enregistré/repris pour cette même LM, sinon null — le backend en attribue
// alors une nouvelle à la soumission / à l'envoi en signature.
export const referenceDuBrouillon = (brouillonLm, formData) =>
  brouillonLm && formData && brouillonLm.cle === cleBrouillon(formData)
    ? brouillonLm.reference || null
    : null;
